import {
  Badge,
  Button,
  Checkbox,
  Chip,
  Collapse,
  Divider,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  Menu,
  Paper,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import {
  createStyles,
  fade,
  makeStyles,
  Theme
} from '@material-ui/core/styles';
import {
  AddRounded,
  ArrowForwardRounded,
  CloseRounded,
  DeleteRounded,
  EditRounded,
  KeyboardArrowDownRounded,
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
  MoreVertRounded,
  RemoveRounded,
  UndoRounded
} from '@material-ui/icons';
import { Alert, Autocomplete, Pagination } from '@material-ui/lab';
import { KeyboardDatePicker } from '../../../components/CustomDatePicker';
import clsx from 'clsx';
import moment from 'moment';
import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { DisciplineLabel, PurposeLabel, RevisionLabel } from '.';
import { BulkProjectDocument } from '../../../api/project-documents';
import { QueryRotateDocument } from '../../../api/rotate-equipment-lists';
import { RootState } from '../../../app/store';
import { ProductNameLabel } from '../../../common/enum/ProductNameLabel';
import {
  BulkDocument,
  BulkDocumentRevision,
  DocumentRevision,
  HistoryDeleteDocumentRevision
} from '../../../common/interface/bulkPlanning';
import { PaginationProps } from '../../../common/interface/pagination';
import BulkUpdateDetail from '../../../components/BulkUpdateDetail';
import ConfirmDeleteBox from '../../../components/ConfirmDeleteBox';
import HelpTooltip from '../../../components/HelpTooltip';
import { SoftButton } from '../../../components/SoftButton';
import WhiteCheckbox from '../../../components/WhiteCheckbox';
import { DAYS_FOR_COMPLETE_REVIEW } from '../../../constants';
import { addWeekdays } from '../../../functions/addWeekdays';
import { useAppDispatch } from '../../../hooks/useAppRudux';
import { useQueryStringNumber } from '../../../hooks/useQueryString';
import AutoAwesomeRounded from '../../../icon/AutoAwesomeRounded';
import ContentCopyOutlined from '../../../icon/ContentCopyOutlined';
import Breadcrumb from '../../Breadcrumb';
import loadingSlice from '../../Loading/loadingSlice';
import { DocumentWithProjectUser } from '../../MasterData/Document/documentSlice';
import { getRotateEquipmentAccessoryWithDocumentsAsync } from '../../MasterData/RotateEquipmentList/rotateEquipmentListSlice';
import { getRotateEquipmentListGroupsAsync } from '../../MasterData/RotateEquipmentListGroup/rotateEquipmentListGroupSlice';
import {
  getRotateQuestionsAsync,
  RotateQuestion
} from '../../MasterData/RotateQuestion/rotateQuestionSlice';
import { getProjectAsync } from '../../Project/projectSlice';
import { User } from '../../UserProfile/userProfileSlice';
import { checkProductType } from '../DocumentCreate';
import {
  bulkCreateProjectDocumentsAsync,
  getAllProjectDocumentNosAsync
} from '../projectDocumentSlice';

interface RotateBulkDocument extends BulkDocument {
  rotateEquipmentListId: number;
}

interface RotateDocumentWithProjectUser extends DocumentWithProjectUser {
  rotateEquipmentListId: number;
}

interface RotateEquipmentListDetails {
  type: string | null;
  name: string | null;
  tag: string | null;
}

interface RotateEquipmentList {
  rotateEquipmentListId: number;
  rotateEquipmentListDetails: RotateEquipmentListDetails[];
}

interface RotateEquipmentListAnswer {
  rotateEquipmentListId: number;
  rotateAnswerId: number;
}

const stepKeys = [
  'bulkPlanning.mre.steps.selectEquipments',
  'bulkPlanning.mre.steps.addDetails',
  'bulkPlanning.steps.customizeTemplate',
  'bulkPlanning.steps.createDocuments'
];

export default function MreBulkPlanning() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const projectId = useQueryStringNumber({ query: 'projectId' });
  const { allProjectDocumentNos } = useSelector(
    (state: RootState) => state.projectDocuments
  );
  const { selectedProject } = useSelector((state: RootState) => state.projects);
  const { data: rotateEquipmentListGroups } = useSelector(
    (state: RootState) => state.rotateEquipmentListGroups
  );
  const { data: rotateQuestions } = useSelector(
    (state: RootState) => state.rotateQuestions
  );
  const { templateWithDocument } = useSelector(
    (state: RootState) => state.rotateEquipmentLists
  );
  const { data: purposes } = useSelector((state: RootState) => state.purposes);
  const { data: revisions } = useSelector(
    (state: RootState) => state.revisions
  );
  const { data: accessControls } = useSelector(
    (state: RootState) => state.accessControls
  );
  const { data: documents } = useSelector(
    (state: RootState) => state.documents
  );
  const { users } = useSelector((state: RootState) => state.projectRegisters);
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.userProfile
  );

  const [selectedDocumentRefIds, setSelectedDocumentRefIds] = useState<
    number[]
  >([]);

  const [selectedDocument, setSelectedDocument] =
    useState<RotateBulkDocument | null>(null);
  const [code, setCode] = useState<{
    plant: string | null;
    area: string | null;
  }>({
    plant: null,
    area: null
  });
  const [pagination, setPagination] = useState<PaginationProps>({
    page: 0,
    limit: 30
  });
  const [selectedEquipmentLists, setSelectedEquipmentLists] = useState<
    RotateEquipmentList[]
  >([]);
  const [selectedAnswers, setSelectedAnswers] = useState<
    RotateEquipmentListAnswer[]
  >([]);
  const defaultDocumentRevisions: DocumentRevision[] = [
    { purposeId: PurposeLabel.IFR, revisionId: RevisionLabel.A },
    { purposeId: PurposeLabel.IFC, revisionId: RevisionLabel.Zero },
    { purposeId: PurposeLabel.IFF, revisionId: RevisionLabel.One }
  ];
  const [documentRevisions, setDocumentRevisions] = useState<
    DocumentRevision[]
  >(defaultDocumentRevisions);
  const [bulkDocuments, setBulkDocuments] = useState<RotateBulkDocument[]>([]);
  const [historyDeleteDocumentRevisions, setHistoryDeleteDocumentRevisions] =
    useState<HistoryDeleteDocumentRevision[]>([]);

  const [activeStep, setActiveStep] = useState<number>(0);
  const [activeEquipmentListTab, setActiveEquipmentListTab] = useState<{
    index: number;
    rotateEquipmentListId: number;
  }>({ index: 0, rotateEquipmentListId: -1 });
  const [openedDocumentRefIds, setOpenedDocumentRefIds] = useState<number[]>(
    []
  );
  const [isEditRevision, setIsEditRevision] = useState<boolean>(false);
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const [isShowAllUsers, setIsShowAllUsers] = useState<boolean>(false);
  const [openedEquipmentListGroupIds, setOpenedEquipmentListGroupIds] =
    useState<number[]>([1]);
  const [openDeleteOneDialog, setOpenDeleteOneDialog] =
    useState<boolean>(false);
  const [openDeleteAllDialog, setOpenDeleteAllDialog] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const originalNo = 'XXX-000-MRE-DAS-XXXX-00';

  useEffect(() => {
    // Prepare the document in the `Create Documents` step only
    if (selectedProject && activeStep === 3) {
      const template: RotateDocumentWithProjectUser[] =
        templateWithDocument.flatMap(({ id, documents }) =>
          documents.map((doc) => ({
            ...doc,
            rotateEquipmentListId: id
          }))
        );
      const projectDocuments = template.map((document, index) => {
        let userIds: number[] = [];
        document.projectPositionWorkflowSteps.forEach(
          (projectPositionWorkflowStep) => {
            if (projectPositionWorkflowStep.projectPosition) {
              projectPositionWorkflowStep.projectPosition.userProjectPositions.forEach(
                (userProjectPosition) =>
                  userIds.push(userProjectPosition.userId)
              );
            }
          }
        );
        // Filter array to have unique values
        userIds = userIds.filter((item, pos) => {
          return userIds.indexOf(item) == pos;
        });

        let documentCreatorId = null;
        // Select document creator from logged in user. If logged in user isn't document creator list, the system will select the first user
        if (userIds.length > 0) {
          documentCreatorId =
            userIds.find((userId) => userId === loggedInUser?.id) ?? userIds[0];
        }

        const projectDocument: RotateBulkDocument = {
          refId: index, // To prevent remove wrong record when deleting document after selecting
          name: document.name,
          no: document.no,
          accessControlId: 2,
          documentCreatorId,
          disciplineId: document.disciplineId,
          documentId: document.id,
          documentGroupName: document.documentGroup?.name || (t('bulkPlanning.common.unassignedGroup') as string),
          documentGroupId: document.documentGroupId,
          isAIMS: false,
          projectId: selectedProject.id,
          projectDocumentRevisions: documentRevisions.map(
            ({ purposeId, revisionId }, index) => {
              return {
                refId: index, // To record order of revision using for undo action
                planIssueDate: null,
                planCompletedDate: null,
                manHour: 1,
                purposeId,
                revisionId,
                isAutoApproval: purposeId === PurposeLabel.IFR
              };
            }
          ),
          userIds,
          rotateEquipmentListId: document.rotateEquipmentListId
        };

        // Magic for selecting REPCO as:
        const repcoId = 7;
        switch (checkProductType(selectedProject.productName)) {
          // 1. Consultant on PMC project
          case ProductNameLabel.pmc:
            projectDocument.consultantId = repcoId;
            break;
          // 2. Main contractor on EPC project
          case ProductNameLabel.epc:
            projectDocument.contractorId = repcoId;
            break;
          default:
            break;
        }

        return projectDocument;
      });
      setBulkDocuments(projectDocuments);

      const firstMatchedDoc = projectDocuments.find(
        (doc) =>
          doc.rotateEquipmentListId ===
          activeEquipmentListTab?.rotateEquipmentListId
      );
      setOpenedDocumentRefIds([firstMatchedDoc?.refId ?? 0]);
    }
  }, [templateWithDocument, activeStep]);

  useEffect(() => {
    if (rotateEquipmentListGroups.length === 0) {
      dispatch(getRotateEquipmentListGroupsAsync());
    }
    if (rotateQuestions.length === 0) {
      dispatch(getRotateQuestionsAsync());
    }
    if (projectId) {
      dispatch(getProjectAsync(projectId));
    }
  }, []);

  function renderBulkDocumentByPage(
    bulkDocuments: RotateBulkDocument[],
    pagination: PaginationProps
  ): RotateBulkDocument[] {
    const startIndex = pagination.page * pagination.limit; // Calculate the starting index
    const endIndex = startIndex + pagination.limit; // Calculate the ending index

    // Use slice to return the documents for the current page
    return bulkDocuments
      .filter(
        ({ rotateEquipmentListId }) =>
          rotateEquipmentListId === activeEquipmentListTab.rotateEquipmentListId
      )
      .slice(startIndex, endIndex);
  }

  function checkDocumentNo(document: RotateBulkDocument): {
    error: boolean;
    helperText: string;
  } {
    // Ensure document.no is not null before proceeding
    if (!document.no) {
      return {
        error: true,
        helperText: t('bulkPlanning.validation.cannotBeBlank')
      };
    }

    // Check if the document number already exists in allProjectDocumentNos
    const isDuplicateCreatedDocument = allProjectDocumentNos.includes(
      document.no
    );
    if (isDuplicateCreatedDocument) {
      return {
        error: true,
        helperText: t('bulkPlanning.validation.numberInUse')
      };
    }

    // Check if the document number already exists in bulkDocuments (excluding the current document)
    const isDuplicateIncomingDocument = bulkDocuments.some(
      (bulkDocument) =>
        bulkDocument !== document && bulkDocument.no === document.no
    );
    if (isDuplicateIncomingDocument) {
      return {
        error: true,
        helperText: t('bulkPlanning.validation.duplicateNumber')
      };
    }

    // If no duplicates are found
    return { error: false, helperText: '' };
  }

  function modifiedNo(originalNo: string): string {
    let arrayFromOriginalNo = originalNo.split('-');
    // Replace plant name (at Position 0, Remove 1 item, and add `plant`)
    if (code.plant) arrayFromOriginalNo.splice(0, 1, code.plant.toUpperCase());
    // Replace area number (at Position 1, Remove 1 item, and add `area`)
    if (code.area) arrayFromOriginalNo.splice(1, 1, code.area.toUpperCase());
    // @See more: https://www.w3schools.com/jsref/jsref_splice.asp
    return arrayFromOriginalNo.join('-');
  }

  function generateRevisionChip(
    { purposeId, revisionId }: DocumentRevision,
    key: number
  ): ReactNode {
    const purpose = purposes.find((purpose) => purpose.id === purposeId);
    const revision = revisions.find((revision) => revision.id === revisionId);

    return (
      <React.Fragment key={key}>
        <Tooltip
          title={`${t('bulkPlanning.tableHeaders.purpose')}: ${purpose?.fullName} | ${t('bulkPlanning.tableHeaders.revision')}: ${revision?.name}`}
          arrow
        >
          <Chip
            className={classes.truncatedChip}
            variant="outlined"
            label={`${t('bulkPlanning.tableHeaders.purpose')}: ${purpose?.abbreviation} | ${t('bulkPlanning.tableHeaders.revision')}: ${revision?.name}`}
          />
        </Tooltip>
      </React.Fragment>
    );
  }

  function nextButton(step: number): { disabled: boolean; action: any } {
    switch (step) {
      case 0:
        return {
          disabled:
            selectedEquipmentLists.length === 0 ||
            selectedEquipmentLists.some((list) =>
              list.rotateEquipmentListDetails.some(
                (detail) =>
                  detail.type === null ||
                  detail.name === null ||
                  detail.tag === null
              )
            ) ||
            loading,
          action: () => {
            setActiveEquipmentListTab({
              ...activeEquipmentListTab,
              index: 0,
              rotateEquipmentListId:
                selectedEquipmentLists[0].rotateEquipmentListId ?? -1
            });
            setSelectedAnswers([]);
            handleNext();
          }
        };

      case 1:
        return {
          disabled:
            !selectedEquipmentLists.every(({ rotateEquipmentListId }) =>
              checkCompletedAnswer(rotateEquipmentListId)
            ) || loading,
          action: handleNext
        };
      case 2:
        return {
          disabled: isEditRevision || loading,
          action: async () => {
            try {
              setLoading(true);
              if (projectId) {
                const query: QueryRotateDocument = {
                  projectId,
                  plant: code.plant,
                  area: code.area,
                  rotateEquipmentLists: selectedEquipmentLists.map(
                    ({ rotateEquipmentListId, rotateEquipmentListDetails }) => {
                      return {
                        rotateEquipmentListId,
                        rotateEquipmentListDetails,
                        rotateAnswerIds: selectedAnswers
                          .filter(
                            (answer) =>
                              answer.rotateEquipmentListId ===
                              rotateEquipmentListId
                          )
                          .map(({ rotateAnswerId }) => rotateAnswerId)
                      };
                    }
                  )
                };
                await dispatch(
                  getRotateEquipmentAccessoryWithDocumentsAsync(query)
                ).unwrap();
                dispatch(
                  getAllProjectDocumentNosAsync({
                    projectId,
                    disciplineIds: [DisciplineLabel.MRE]
                  })
                );
                setSelectedDocumentRefIds([]);
                setHistoryDeleteDocumentRevisions([]);
                setActiveEquipmentListTab({
                  ...activeEquipmentListTab,
                  index: 0,
                  rotateEquipmentListId:
                    selectedEquipmentLists[0].rotateEquipmentListId ?? -1
                });
                setPagination({ ...pagination, page: 0 });
                setTimeout(() => {
                  handleNext();
                  setLoading(false);
                }, 250);
              }
            } catch {
              setLoading(false);
            }
          }
        };
      case 3:
        return {
          disabled:
            bulkDocuments.length === 0 ||
            bulkDocuments.some(
              (document) =>
                !document.name ||
                !document.no ||
                !document.accessControlId ||
                !document.documentCreatorId ||
                document.projectDocumentRevisions.some(
                  (documentRevision) =>
                    !documentRevision.purposeId ||
                    !documentRevision.revisionId ||
                    !documentRevision.manHour ||
                    !documentRevision.planIssueDate ||
                    !documentRevision.planCompletedDate
                )
            ) ||
            bulkDocuments.some(
              (bulkDocument) =>
                bulkDocument.no &&
                allProjectDocumentNos.includes(bulkDocument.no)
            ) ||
            bulkDocuments.some((bulkDocument) =>
              bulkDocuments
                .filter((document) => document.refId !== bulkDocument.refId)
                .some((document) => document.no === bulkDocument.no)
            ) ||
            loading,
          action: handleNext // The action in this step doesn't use, we will use `onSubmit` function instead
        };
      default:
        return { disabled: true, action: handleNext };
    }
  }

  function handleNext(): void {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  function handleBack(): void {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }

  function handleChangePage(
    event: React.ChangeEvent<unknown>,
    value: number
  ): void {
    setPagination({ ...pagination, page: value - 1 }); // The first value of pagination is 1, not 0
    setSelectedDocumentRefIds([]);
    if (pagination.page !== value - 1)
      window['scrollTo']({ top: 0, behavior: 'smooth' });
  }

  function handleEditRevision(): void {
    setIsEditRevision((prevEdit) => !prevEdit);
  }

  function handleOpenRotateEquipmentListGroup(id: number): void {
    const open = getStatus(id, openedEquipmentListGroupIds);
    if (open) {
      setOpenedEquipmentListGroupIds(
        openedEquipmentListGroupIds.filter(
          (openedRotateEquipmentListGroupId) =>
            openedRotateEquipmentListGroupId !== id
        )
      );
    } else {
      setOpenedEquipmentListGroupIds([...openedEquipmentListGroupIds, id]);
    }
  }

  function handleSelectRotateEquipmentList(
    id: number,
    type: string | null
  ): void {
    const isSelected = selectedEquipmentLists.some(
      ({ rotateEquipmentListId }) => rotateEquipmentListId === id
    );

    if (isSelected) {
      setSelectedEquipmentLists((prev) =>
        prev.filter(({ rotateEquipmentListId }) => rotateEquipmentListId !== id)
      );
    } else {
      const newList: RotateEquipmentList = {
        rotateEquipmentListId: id,
        rotateEquipmentListDetails: [{ type, name: null, tag: null }]
      };

      setSelectedEquipmentLists((prev) =>
        [...prev, newList].sort(
          (a, b) => a.rotateEquipmentListId - b.rotateEquipmentListId
        )
      );
    }
  }

  function handleEquipmentListDetail(
    id: number,
    action: 'add' | 'remove',
    type: string | null,
    index?: number
  ): void {
    const targetList = selectedEquipmentLists.find(
      (list) => list.rotateEquipmentListId === id
    );
    if (!targetList) return;

    const details = [...targetList.rotateEquipmentListDetails];

    if (action === 'remove' && (index === undefined || details.length <= 1)) {
      setSelectedEquipmentLists((prev) =>
        prev.filter((list) => list.rotateEquipmentListId !== id)
      );
      return;
    }

    const updatedLists = selectedEquipmentLists.map((list) => {
      if (list.rotateEquipmentListId !== id) return list;

      let updatedDetails = [...list.rotateEquipmentListDetails];

      if (action === 'add') {
        updatedDetails.push({ type, name: null, tag: null });
      } else if (action === 'remove' && index !== undefined) {
        updatedDetails.splice(index, 1);
      }

      return {
        ...list,
        rotateEquipmentListDetails: updatedDetails
      };
    });

    setSelectedEquipmentLists(updatedLists);
  }

  function onChangeTextFieldEquipmentListDetail(
    value: string,
    type: keyof RotateEquipmentListDetails,
    id: number,
    index: number
  ): void {
    const updatedLists = selectedEquipmentLists.map((list) => {
      if (list.rotateEquipmentListId !== id) return list;

      const updatedDetails = list.rotateEquipmentListDetails.map(
        (detail, idx) => {
          if (idx !== index) return detail;
          return {
            ...detail,
            [type]: value === '' ? null : value
          };
        }
      );

      return {
        ...list,
        rotateEquipmentListDetails: updatedDetails
      };
    });

    setSelectedEquipmentLists(updatedLists);
  }

  function handleChangeEquipmentTab(
    event: React.ChangeEvent<{}>,
    newValue: number
  ) {
    const rotateEquipmentListId =
      selectedEquipmentLists[newValue].rotateEquipmentListId;
    setActiveEquipmentListTab({
      ...activeEquipmentListTab,
      index: newValue,
      rotateEquipmentListId
    });
    if (activeStep === 3) {
      setPagination({ ...pagination, page: 0 });
      setSelectedDocumentRefIds([]);
      const firstMatchedDoc = bulkDocuments.find(
        (doc) => doc.rotateEquipmentListId === rotateEquipmentListId
      );
      setOpenedDocumentRefIds([firstMatchedDoc?.refId ?? 0]);
    }
  }

  function handleSelectedAnswer(
    isMultiple: boolean,
    rotateEquipmentListId: number,
    rotateQuestionId: number,
    rotateAnswerId: number,
    checked: boolean
  ): void {
    setSelectedAnswers((prev) => {
      let newAnswers = [...prev];

      const matchedQuestions = rotateQuestions.filter((question) =>
        question.hideForEquipmentListAnswerRelations?.some(
          (relation) =>
            relation.rotateEquipmentListId === rotateEquipmentListId &&
            relation.rotateAnswerId === rotateAnswerId
        )
      );

      if (checked && matchedQuestions.length > 0) {
        const allAnswerIdsToRemove = matchedQuestions.flatMap((question) =>
          question.rotateAnswers.map((answer) => answer.id)
        );

        newAnswers = newAnswers.filter(
          (answer) =>
            answer.rotateEquipmentListId !== rotateEquipmentListId ||
            !allAnswerIdsToRemove.includes(answer.rotateAnswerId)
        );
      }

      if (checked) {
        if (isMultiple) {
          return [...newAnswers, { rotateEquipmentListId, rotateAnswerId }];
        } else {
          const allRotateAnswerIds =
            rotateQuestions
              .find(({ id }) => id === rotateQuestionId)
              ?.rotateAnswers.map(({ id }) => id) ?? [];
          return [
            ...newAnswers.filter(
              (answer) =>
                answer.rotateEquipmentListId !== rotateEquipmentListId ||
                !allRotateAnswerIds.includes(answer.rotateAnswerId)
            ),
            { rotateEquipmentListId, rotateAnswerId }
          ];
        }
      } else {
        return newAnswers.filter(
          (answer) =>
            !(
              answer.rotateEquipmentListId === rotateEquipmentListId &&
              answer.rotateAnswerId === rotateAnswerId
            )
        );
      }
    });
  }

  function handleClickEquipment(rotateEquipmentListId?: number): void {
    if (rotateEquipmentListId) {
      const index = selectedEquipmentLists.findIndex(
        (list) => list.rotateEquipmentListId === rotateEquipmentListId
      );
      setActiveEquipmentListTab({
        ...activeEquipmentListTab,
        index,
        rotateEquipmentListId
      });
      window['scrollTo']({ top: 0, behavior: 'smooth' });
    }
  }

  function checkCompletedAnswer(rotateEquipmentListId: number): boolean {
    // 1. Get only visible & required questions for this equipment
    const visibleRequiredQuestions = rotateQuestions.filter((question) => {
      if (!question.isRequired) return false;

      // Check if question is hidden for this equipment
      const isHiddenByEquipment = question.hideForEquipmentListRelations?.some(
        (relation) => relation.rotateEquipmentListId === rotateEquipmentListId
      );

      // Check if hidden by selected answer for this equipment
      const isHiddenByAnswer =
        question.hideForEquipmentListAnswerRelations?.some(
          ({ rotateEquipmentListId: relEquipId, rotateAnswerId }) =>
            relEquipId === rotateEquipmentListId &&
            selectedAnswers.some(
              (answer) =>
                answer.rotateEquipmentListId === relEquipId &&
                answer.rotateAnswerId === rotateAnswerId
            )
        );

      return !isHiddenByEquipment && !isHiddenByAnswer;
    });

    // 2. Ensure all visible required questions have at least one selected answer
    return visibleRequiredQuestions.every((question) =>
      selectedAnswers.some(
        (answer) =>
          answer.rotateEquipmentListId === rotateEquipmentListId &&
          question.rotateAnswers.some(
            (qAnswer) => qAnswer.id === answer.rotateAnswerId
          )
      )
    );
  }

  function nextEquipmentToComplete(rotateEquipmentListId: number): {
    nextEquipment: RotateEquipmentList | null;
    nextEquipmentName: string | null;
  } {
    const currentIndex = selectedEquipmentLists.findIndex(
      (list) => list.rotateEquipmentListId === rotateEquipmentListId
    );

    if (currentIndex === -1) {
      return { nextEquipment: null, nextEquipmentName: null };
    }

    const total = selectedEquipmentLists.length;

    // Loop through the list starting from the next index, wrapping around
    for (let offset = 1; offset < total; offset++) {
      const checkIndex = (currentIndex + offset) % total;
      const checkingEquipment = selectedEquipmentLists[checkIndex];

      const isComplete = checkCompletedAnswer(
        checkingEquipment.rotateEquipmentListId
      );
      if (!isComplete) {
        return {
          nextEquipment: checkingEquipment,
          nextEquipmentName:
            getEquipmentListName(checkingEquipment.rotateEquipmentListId) ??
            `Next Equipment`
        };
      }
    }

    // All equipment lists are completed
    return { nextEquipment: null, nextEquipmentName: null };
  }

  function checkDocumentDetail(rotateEquipmentListId: number): {
    count: number;
    isCompleted: boolean;
  } {
    const relatedRotateDocument = bulkDocuments.filter(
      (document) => document.rotateEquipmentListId === rotateEquipmentListId
    );
    const count = relatedRotateDocument.length;
    const isCompleted = relatedRotateDocument.every((document) => {
      return (
        document.name &&
        document.no &&
        document.accessControlId &&
        document.documentCreatorId &&
        document.disciplineId &&
        document.documentId &&
        document.projectId &&
        document.projectDocumentRevisions.every((revision) => {
          return (
            revision.planIssueDate &&
            revision.planCompletedDate &&
            revision.manHour &&
            revision.purposeId &&
            revision.revisionId
          );
        })
      );
    });

    return { count, isCompleted };
  }

  function getEquipmentListName(rotateEquipmentListId: number): string {
    return (
      rotateEquipmentListGroups
        .flatMap(({ rotateEquipmentLists }) => rotateEquipmentLists)
        .find(({ id }) => id === rotateEquipmentListId)?.name ?? ''
    );
  }

  function handleOpenDocument(refId: number): void {
    const open = getStatus(refId, openedDocumentRefIds);
    if (open) {
      // If the document is already open, remove it from the list
      setOpenedDocumentRefIds(
        openedDocumentRefIds.filter(
          (openedDocumentRefId) => openedDocumentRefId !== refId
        )
      );
    } else {
      // Add the document to the list, ensuring a maximum of 5 documents
      setOpenedDocumentRefIds((prevRefIds) => {
        const updatedRefs = [...prevRefIds, refId];
        return updatedRefs.length > 5 ? updatedRefs.slice(1) : updatedRefs;
      });
    }
  }

  function handleSelectDocumentGroup(
    checked: boolean,
    documentGroupId: number | null
  ): void {
    const documentRefIdsInGroup = renderBulkDocumentByPage(
      bulkDocuments,
      pagination
    )
      .filter((doc) => doc.documentGroupId === documentGroupId)
      .map((doc) => doc.refId);

    if (checked) {
      // Add unique refIds from this group
      const newSelected = Array.from(
        new Set([...selectedDocumentRefIds, ...documentRefIdsInGroup])
      );
      setSelectedDocumentRefIds(newSelected);
    } else {
      // Remove only refIds that are in the group
      const filtered = selectedDocumentRefIds.filter(
        (refId) => !documentRefIdsInGroup.includes(refId)
      );
      setSelectedDocumentRefIds(filtered);
    }
  }

  function handleSelectDocument(checked: boolean, refId?: number) {
    if (refId !== undefined) {
      // Click from each document
      if (checked) {
        setSelectedDocumentRefIds([...selectedDocumentRefIds, refId]);
      } else {
        setSelectedDocumentRefIds(
          selectedDocumentRefIds.filter(
            (documentRefId) => documentRefId !== refId
          )
        );
      }
    } else {
      // Click from header of document table
      if (checked) {
        const allDocumentRefIds = renderBulkDocumentByPage(
          bulkDocuments,
          pagination
        ).map(({ refId }) => refId);
        setSelectedDocumentRefIds(allDocumentRefIds);
      } else {
        setSelectedDocumentRefIds([]);
      }
    }
  }

  function getStatus(value: number, selectedItems: number[]): boolean {
    return selectedItems.indexOf(value) !== -1;
  }

  function getValue<T extends { id: number }>(
    id: number | null,
    options: T[]
  ): T | null {
    return options.find((option) => option.id === id) ?? null;
  }

  function handleChangeTextField(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    const { name, value } = event.target;
    setCode({
      ...code,
      [name]: value === '' ? null : value.toUpperCase().substring(0, 3)
    });
  }

  function handleChangeRevisionTemplate<K extends keyof DocumentRevision>(
    value: DocumentRevision[K],
    field: K,
    index: number
  ): void {
    const documentRevision = documentRevisions[index];

    // Create updated revision object
    const updatedDocumentRevision = {
      ...documentRevision,
      [field]: value ?? null
    };

    // Reset `revisionId` if `purposeId` is changed
    if (field === 'purposeId') {
      updatedDocumentRevision.revisionId = null;
    }

    // Update the specific revision in place
    documentRevisions.splice(index, 1, updatedDocumentRevision);
    setDocumentRevisions([...documentRevisions]);
  }

  function handleRemoveRevisionTemplate(index: number): void {
    // Remove the revision at the specified index
    documentRevisions.splice(index, 1);
    setDocumentRevisions([...documentRevisions]);
  }

  function handleNewRevisionTemplate(): void {
    setDocumentRevisions([
      ...documentRevisions,
      { purposeId: null, revisionId: null }
    ]);
  }

  function handleResetRevisionTemplate(): void {
    setDocumentRevisions(defaultDocumentRevisions);
  }

  function handleAnchorElement(
    open: boolean
  ): (event: React.MouseEvent<HTMLButtonElement>) => void {
    return function (event: React.MouseEvent<HTMLButtonElement>) {
      setAnchorElement(open ? event.currentTarget : null);
    };
  }

  function getRelatedUser(userIds: number[], users: User[]): User[] {
    return !isShowAllUsers
      ? users.filter((user) => userIds.some((userId) => userId === user.id))
      : users;
  }

  function handleChangeRelatedUsers(): void {
    setIsShowAllUsers((prev) => !prev);
  }

  function handleDuplicateDocument(document: RotateBulkDocument): void {
    // Find the maximum `redId` in `bulkDocuments`
    const maxRefId = Math.max(
      ...bulkDocuments.map((document) => document.refId)
    );

    // Create a new document by duplicating the selected document and assigning a new `refId`
    const newDocument = {
      ...document,
      refId: maxRefId + 1, // New `refId`
      projectDocumentRevisions: document.projectDocumentRevisions.map(
        (revision) => ({
          ...revision
        })
      )
    };

    // Find the index of the selected document in `bulkDocuments`
    const documentIndex = bulkDocuments.findIndex(
      (doc) => doc.refId === document.refId
    );

    // Add the new document next to the selected document
    bulkDocuments.splice(documentIndex + 1, 0, newDocument);

    // Check if the new document is on a new page
    const lastDocumentIndexInThisPage =
      pagination.page * pagination.limit + pagination.limit - 1;
    const isNewPage = documentIndex + 1 > lastDocumentIndexInThisPage;
    const newPage = isNewPage ? pagination.page + 1 : pagination.page;

    setPagination({ ...pagination, page: newPage });
    setBulkDocuments([...bulkDocuments]);

    if (isNewPage) window['scrollTo']({ top: 0, behavior: 'smooth' });
  }

  function handleChangeDocumentDetail<K extends keyof RotateBulkDocument>(
    value: RotateBulkDocument[K],
    field: K,
    refId: number
  ): void {
    const documentIndex = bulkDocuments.findIndex(
      (document) => document.refId === refId
    );
    if (documentIndex === -1) return;
    const document = bulkDocuments[documentIndex];

    const newDocument = { ...document, [field]: value === '' ? null : value };

    bulkDocuments.splice(documentIndex, 1, newDocument);
    setBulkDocuments([...bulkDocuments]);
  }

  function handleChangeDocumentRevisionDetail<
    K extends keyof BulkDocumentRevision
  >(
    value: BulkDocumentRevision[K],
    field: K,
    refId: number,
    documentRevisionIndex: number,
    options?: { positiveNumber: boolean }
  ): void {
    const documentIndex = bulkDocuments.findIndex(
      (document) => document.refId === refId
    );
    if (documentIndex === -1) return;
    const document = bulkDocuments[documentIndex];
    const documentRevision =
      document.projectDocumentRevisions[documentRevisionIndex];

    const newDocumentRevision = {
      ...documentRevision,
      [field]:
        options?.positiveNumber && typeof value === 'number'
          ? value <= 0
            ? null
            : value
          : value
    };
    if (field === 'purposeId') {
      newDocumentRevision.revisionId = null;
      newDocumentRevision.isAutoApproval = value === PurposeLabel.IFR;
    }
    if (field === 'planIssueDate') {
      if (value instanceof Date) {
        newDocumentRevision.planCompletedDate = addWeekdays(
          value,
          DAYS_FOR_COMPLETE_REVIEW
        );
      } else {
        newDocumentRevision.planCompletedDate = null;
      }
    }

    document.projectDocumentRevisions.splice(
      documentRevisionIndex,
      1,
      newDocumentRevision
    );
    bulkDocuments.splice(documentIndex, 1, {
      ...document,
      projectDocumentRevisions: document.projectDocumentRevisions
    });
    setBulkDocuments([...bulkDocuments]);
  }

  function handleOpenDeleteOneDialog(document?: RotateBulkDocument): void {
    setOpenDeleteOneDialog((prev) => !prev);
    if (document) setSelectedDocument(document);
  }

  function handleOpenDeleteAllDialog(): void {
    setOpenDeleteAllDialog((prev) => !prev);
  }

  async function onReset(): Promise<void> {
    if (projectId) {
      const query: QueryRotateDocument = {
        projectId,
        plant: code.plant,
        area: code.area,
        rotateEquipmentLists: selectedEquipmentLists.map(
          ({ rotateEquipmentListId, rotateEquipmentListDetails }) => {
            return {
              rotateEquipmentListId,
              rotateEquipmentListDetails,
              rotateAnswerIds: selectedAnswers
                .filter(
                  (answer) =>
                    answer.rotateEquipmentListId === rotateEquipmentListId
                )
                .map(({ rotateAnswerId }) => rotateAnswerId)
            };
          }
        )
      };
      await dispatch(
        getRotateEquipmentAccessoryWithDocumentsAsync(query)
      ).unwrap();
      setPagination({ ...pagination, page: 0 });
    }
  }

  function onDeleteDocument(): void {
    if (selectedDocument) {
      const newDocument = bulkDocuments.filter(
        (document) => document.refId !== selectedDocument.refId
      );
      const newOpenedDocumentRefIds = openedDocumentRefIds.filter(
        (refId) => selectedDocument.refId !== refId
      );
      const newHistoryDeleteDocumentRevisions =
        historyDeleteDocumentRevisions.filter(
          ({ refDocumentId }) => selectedDocument.refId !== refDocumentId
        );
      const newSelectedDocumentRefIds = selectedDocumentRefIds.filter(
        (refId) => selectedDocument.refId !== refId
      );
      setBulkDocuments(newDocument);
      setOpenedDocumentRefIds(newOpenedDocumentRefIds);
      setHistoryDeleteDocumentRevisions(newHistoryDeleteDocumentRevisions);
      setSelectedDocumentRefIds(newSelectedDocumentRefIds);

      // Navigate to previous page if the deleted document is the last row
      const isLastRow =
        renderBulkDocumentByPage(bulkDocuments, pagination).length === 1;
      const newPage = Math.max(
        isLastRow ? pagination.page - 1 : pagination.page,
        0
      );
      setPagination({ ...pagination, page: newPage });
      if (isLastRow) window['scrollTo']({ top: 0, behavior: 'smooth' });

      setOpenDeleteOneDialog(false);
    }
  }

  function onDeleteSelectedDocuments(): void {
    const newDocument = bulkDocuments.filter((document) =>
      selectedDocumentRefIds.every((refId) => refId !== document.refId)
    );
    const newOpenedDocumentRefIds = openedDocumentRefIds.filter((id) =>
      selectedDocumentRefIds.every((refId) => refId !== id)
    );
    const newHistoryDeleteDocumentRevisions =
      historyDeleteDocumentRevisions.filter(({ refDocumentId }) =>
        selectedDocumentRefIds.every((refId) => refId !== refDocumentId)
      );
    setBulkDocuments(newDocument);
    setOpenedDocumentRefIds(newOpenedDocumentRefIds);
    setHistoryDeleteDocumentRevisions(newHistoryDeleteDocumentRevisions);
    setSelectedDocumentRefIds([]);

    // Navigate to previous page if the all document is deleted
    const newPage = Math.max(pagination.page - 1, 0);
    setPagination({ ...pagination, page: newPage });
    window['scrollTo']({ top: 0, behavior: 'smooth' });

    setOpenDeleteAllDialog(false);
  }

  function onDeleteDocumentRevision(
    document: RotateBulkDocument,
    documentRevision: BulkDocumentRevision
  ): void {
    const documentIndex = bulkDocuments.findIndex(
      ({ refId }) => refId === document.refId
    );
    if (documentIndex >= 0) {
      // Collect deleted revision to history called `historyDeleteDocumentRevisions`
      const historyDocumentRevision: HistoryDeleteDocumentRevision = {
        refDocumentId: document.refId,
        projectDocumentRevision: documentRevision
      };
      setHistoryDeleteDocumentRevisions([
        historyDocumentRevision,
        ...historyDeleteDocumentRevisions
      ]);
      // Remove the revision from selected projectDocumentRevisions
      const newDocumentRevisions = document.projectDocumentRevisions.filter(
        ({ refId }) => refId !== documentRevision.refId
      );

      bulkDocuments[documentIndex] = {
        ...document,
        projectDocumentRevisions: newDocumentRevisions
      };
      setBulkDocuments([...bulkDocuments]);
    }
  }

  function onUndoDocumentRevision(document?: RotateBulkDocument): void {
    if (document) {
      const history = historyDeleteDocumentRevisions.find(
        ({ refDocumentId }) => refDocumentId === document.refId
      );

      if (history) {
        const { projectDocumentRevision } = history;
        const documentIndex = bulkDocuments.findIndex(
          ({ refId }) => refId === document.refId
        );

        if (documentIndex >= 0) {
          // Restore the latest deleted document revision
          const newDocumentRevisions = [
            ...document.projectDocumentRevisions,
            projectDocumentRevision
          ].sort((a, b) => a.refId - b.refId);

          bulkDocuments[documentIndex] = {
            ...document,
            projectDocumentRevisions: newDocumentRevisions
          };
          setBulkDocuments([...bulkDocuments]);

          // Remove from history
          setHistoryDeleteDocumentRevisions(
            historyDeleteDocumentRevisions.filter(
              (history) =>
                !(
                  history.refDocumentId === document.refId &&
                  history.projectDocumentRevision.refId ===
                    projectDocumentRevision.refId
                )
            )
          );
        }
      }
    } else {
      const latestDeleteDocumentRevision = historyDeleteDocumentRevisions[0];
      if (latestDeleteDocumentRevision) {
        const { refDocumentId } = latestDeleteDocumentRevision;

        const document = bulkDocuments.find(
          ({ refId }) => refId === refDocumentId
        );

        if (document) {
          onUndoDocumentRevision(document);
        }
      }
    }
  }

  function renderQuestion(questions: RotateQuestion[]): RotateQuestion[] {
    if (!activeEquipmentListTab) return [];

    const activeId = activeEquipmentListTab.rotateEquipmentListId;

    return questions
      .filter((question) => {
        // 1. Hide if this question is blocked for current equipment list
        const isHiddenByEquipment =
          question.hideForEquipmentListRelations?.some(
            (relation) => relation.rotateEquipmentListId === activeId
          );

        // 2. Hide if any selectedAnswer matches the hideForEquipmentListAnswerRelations
        const isHiddenByAnswer =
          question.hideForEquipmentListAnswerRelations?.some(
            ({ rotateEquipmentListId, rotateAnswerId }) =>
              rotateEquipmentListId === activeId &&
              selectedAnswers.some(
                (answer) =>
                  answer.rotateEquipmentListId === rotateEquipmentListId &&
                  answer.rotateAnswerId === rotateAnswerId
              )
          );

        return !isHiddenByEquipment && !isHiddenByAnswer;
      })
      .map((question) => ({
        ...question,
        rotateAnswers: question.rotateAnswers.filter(
          (answer) =>
            !answer.hideForEquipmentListRelations?.some(
              (relation) => relation.rotateEquipmentListId === activeId
            )
        )
      }));
  }

  async function onSubmit(
    event: React.FormEvent<HTMLFormElement>
  ): Promise<void> {
    event.preventDefault();

    // Add condition to check the value of bulkDocuments
    const isValidBulkDocuments = bulkDocuments.every((document) => {
      return (
        document.name &&
        document.no &&
        document.accessControlId &&
        document.documentCreatorId &&
        document.disciplineId &&
        document.documentId &&
        document.projectId &&
        document.projectDocumentRevisions.every((revision) => {
          return (
            revision.planIssueDate &&
            revision.planCompletedDate &&
            revision.manHour &&
            revision.purposeId &&
            revision.revisionId
          );
        })
      );
    });

    try {
      setLoading(true);
      if (isValidBulkDocuments) {
        await dispatch(
          bulkCreateProjectDocumentsAsync({
            projectDocuments: bulkDocuments as BulkProjectDocument[]
          })
        ).unwrap();
        dispatch(
          loadingSlice.actions.success({
            message: t('bulkPlanning.common.documentsCreatedSuccess')
          })
        );
        handleNext();
        setTimeout(() => {
          if (projectId) history.push(`/projects/${projectId}`);
        }, 1000);
      } else {
        throw new Error(t('bulkPlanning.common.checkAllFields') as string);
      }
    } catch (error) {
      setLoading(false);
      if (error instanceof Error)
        dispatch(
          loadingSlice.actions.error({
            message: error.message
          })
        );
    }
  }

  if (!projectId) {
    return <Redirect to="/projects" />;
  }

  return (
    <div className={classes.root}>
      <Breadcrumb
        name="createBulkPlanning"
        data={{
          projectName: selectedProject?.name,
          projectId: selectedProject?.id,
          createBulkPlanning: 'MRE'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('bulkPlanning.titles.MRE')}
      </Typography>
      <Stepper
        className={classes.card}
        component={Paper}
        activeStep={activeStep}
        alternativeLabel
      >
        {stepKeys.map((key) => (
          <Step key={key}>
            <StepLabel>{t(key)}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <form onSubmit={onSubmit}>
        <Paper className={classes.card}>
          <Collapse in={activeStep === 0}>
            <Typography variant="h6" display="inline">
              {t('bulkPlanning.mre.equipmentList')}
            </Typography>
            <Divider className={classes.divider} />
            <TableContainer style={{ overflowY: 'hidden' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell width={52} />
                    <TableCell className={clsx(classes.flexGrow, classes.px0)}>
                      {t('bulkPlanning.mre.equipmentDescription')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                {activeStep === 0 && (
                  <TableBody>
                    {rotateEquipmentListGroups.map(
                      ({ id, name, rotateEquipmentLists }, index) => {
                        const open = getStatus(id, openedEquipmentListGroupIds);
                        const count = selectedEquipmentLists
                          .filter(({ rotateEquipmentListId }) =>
                            rotateEquipmentLists.some(
                              ({ id }) => id === rotateEquipmentListId
                            )
                          )
                          .flatMap(
                            ({ rotateEquipmentListDetails }) =>
                              rotateEquipmentListDetails
                          ).length;

                        return (
                          <React.Fragment key={index}>
                            <TableRow
                              className={clsx(
                                classes.clickable,
                                classes.unsetAll
                              )}
                              hover
                              onClick={() =>
                                handleOpenRotateEquipmentListGroup(id)
                              }
                            >
                              <TableCell
                                padding="none"
                                align="center"
                                width={52}
                              >
                                <IconButton size="small">
                                  {open ? (
                                    <KeyboardArrowDownRounded />
                                  ) : (
                                    <KeyboardArrowRightRounded />
                                  )}
                                </IconButton>
                              </TableCell>
                              <TableCell className={classes.px0}>
                                {name}
                                {count > 0 ? ` (${count})` : ''}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell padding="none" colSpan={2}>
                                <Collapse in={open}>
                                  <Table size="small">
                                    <TableBody>
                                      {rotateEquipmentLists.map(
                                        ({ id, name, isCustomName }, index) => {
                                          const selected = getStatus(
                                            id,
                                            selectedEquipmentLists.map(
                                              ({ rotateEquipmentListId }) =>
                                                rotateEquipmentListId
                                            )
                                          );
                                          const count = selectedEquipmentLists
                                            .filter(
                                              ({ rotateEquipmentListId }) =>
                                                rotateEquipmentListId === id
                                            )
                                            .flatMap(
                                              ({
                                                rotateEquipmentListDetails
                                              }) => rotateEquipmentListDetails
                                            ).length;
                                          return (
                                            <React.Fragment key={index}>
                                              <TableRow
                                                classes={{
                                                  root: clsx(classes.unsetAll, {
                                                    [classes.tableRowRoot]:
                                                      selected
                                                  }),
                                                  selected: clsx({
                                                    [classes.tableRowSelected]:
                                                      selected
                                                  })
                                                }}
                                                hover
                                                selected={selected}
                                              >
                                                <TableCell padding="checkbox">
                                                  <Checkbox
                                                    checked={selected}
                                                    color="primary"
                                                    onClick={() =>
                                                      handleSelectRotateEquipmentList(
                                                        id,
                                                        isCustomName
                                                          ? null
                                                          : name
                                                      )
                                                    }
                                                  />
                                                </TableCell>
                                                <TableCell
                                                  className={classes.px0}
                                                  colSpan={4}
                                                >
                                                  {name}
                                                </TableCell>
                                              </TableRow>
                                              {count > 0 && (
                                                <TableRow>
                                                  <TableCell
                                                    className={classes.unset}
                                                  />
                                                  <TableCell
                                                    className={classes.px0}
                                                  >
                                                    <Typography variant="subtitle2">
                                                      {t('bulkPlanning.mre.type')}
                                                    </Typography>
                                                  </TableCell>
                                                  <TableCell>
                                                    <Typography variant="subtitle2">
                                                      {t('bulkPlanning.mre.tag')}
                                                    </Typography>
                                                  </TableCell>
                                                  <TableCell>
                                                    <Typography variant="subtitle2">
                                                      {t('bulkPlanning.mre.name')}
                                                    </Typography>
                                                  </TableCell>
                                                  <TableCell padding="none">
                                                    <IconButton
                                                      size="small"
                                                      onClick={() =>
                                                        handleEquipmentListDetail(
                                                          id,
                                                          'add',
                                                          isCustomName
                                                            ? null
                                                            : name
                                                        )
                                                      }
                                                    >
                                                      <AddRounded />
                                                    </IconButton>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {selectedEquipmentLists.map(
                                                (list) =>
                                                  list.rotateEquipmentListId ===
                                                    id &&
                                                  list.rotateEquipmentListDetails.map(
                                                    (
                                                      { type, tag, name },
                                                      index
                                                    ) => (
                                                      <TableRow
                                                        className={
                                                          classes.unsetAll
                                                        }
                                                        key={`${list.rotateEquipmentListId}-${index}`}
                                                      >
                                                        <TableCell />
                                                        <TableCell
                                                          className={
                                                            classes.px0
                                                          }
                                                        >
                                                          {isCustomName ? (
                                                            <TextField
                                                              size="small"
                                                              placeholder={t('bulkPlanning.specificName') as string}
                                                              value={type ?? ''}
                                                              onChange={(
                                                                event
                                                              ) =>
                                                                onChangeTextFieldEquipmentListDetail(
                                                                  event.target
                                                                    .value,
                                                                  'type',
                                                                  id,
                                                                  index
                                                                )
                                                              }
                                                              fullWidth
                                                              required
                                                            />
                                                          ) : (
                                                            type
                                                          )}
                                                        </TableCell>
                                                        <TableCell>
                                                          <TextField
                                                            size="small"
                                                            value={tag ?? ''}
                                                            onChange={(event) =>
                                                              onChangeTextFieldEquipmentListDetail(
                                                                event.target
                                                                  .value,
                                                                'tag',
                                                                id,
                                                                index
                                                              )
                                                            }
                                                            fullWidth
                                                            required
                                                          />
                                                        </TableCell>
                                                        <TableCell>
                                                          <TextField
                                                            size="small"
                                                            value={name ?? ''}
                                                            onChange={(event) =>
                                                              onChangeTextFieldEquipmentListDetail(
                                                                event.target
                                                                  .value,
                                                                'name',
                                                                id,
                                                                index
                                                              )
                                                            }
                                                            fullWidth
                                                            required
                                                          />
                                                        </TableCell>
                                                        <TableCell padding="none">
                                                          <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                              handleEquipmentListDetail(
                                                                id,
                                                                'remove',
                                                                isCustomName
                                                                  ? null
                                                                  : name,
                                                                index
                                                              )
                                                            }
                                                          >
                                                            <RemoveRounded />
                                                          </IconButton>
                                                        </TableCell>
                                                      </TableRow>
                                                    )
                                                  )
                                              )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      }
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Collapse>
          <Collapse in={activeStep === 1}>
            <Typography variant="h6" display="inline">
              {t('bulkPlanning.mre.equipmentDetails')}
            </Typography>
            <Divider className={classes.divider} />
            {activeStep === 1 && (
              <>
                <Tabs
                  indicatorColor="primary"
                  textColor="primary"
                  value={activeEquipmentListTab.index}
                  onChange={handleChangeEquipmentTab}
                >
                  {selectedEquipmentLists.map(({ rotateEquipmentListId }) => {
                    const label = getEquipmentListName(rotateEquipmentListId);
                    return (
                      <Tab
                        label={`${label} ${
                          checkCompletedAnswer(rotateEquipmentListId)
                            ? '✅'
                            : '⏳'
                        }`}
                        key={label}
                      />
                    );
                  })}
                </Tabs>
                <Divider />
                <div className={classes.equipmentDetailField}>
                  <Typography component="span">
                    Select the equipment details for
                  </Typography>
                  {selectedEquipmentLists
                    .find(
                      ({ rotateEquipmentListId }) =>
                        rotateEquipmentListId ===
                        activeEquipmentListTab.rotateEquipmentListId
                    )
                    ?.rotateEquipmentListDetails.map(({ tag, name }, index) => {
                      return (
                        <Chip
                          label={`${name} (${tag})`}
                          variant="outlined"
                          key={index}
                        />
                      );
                    })}
                </div>
                <Typography color="error" variant="caption">
                  * Required
                </Typography>
                {renderQuestion(rotateQuestions).map(
                  (rotateQuestion, index) => {
                    return (
                      <React.Fragment key={rotateQuestion.id}>
                        <div className={classes.pt2}>
                          <Typography component="span">
                            {index + 1}. {rotateQuestion.name}
                          </Typography>
                          {rotateQuestion.isRequired && (
                            <Typography color="error" component="span">
                              {' '}
                              *
                            </Typography>
                          )}
                        </div>
                        {rotateQuestion.isMultiple ? (
                          <>
                            <FormGroup>
                              {rotateQuestion.rotateAnswers.map(
                                ({ id, name }) => {
                                  return (
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          color="primary"
                                          checked={selectedAnswers.some(
                                            ({
                                              rotateEquipmentListId,
                                              rotateAnswerId
                                            }) =>
                                              rotateEquipmentListId ===
                                                activeEquipmentListTab.rotateEquipmentListId &&
                                              rotateAnswerId === id
                                          )}
                                          onChange={(event) =>
                                            handleSelectedAnswer(
                                              rotateQuestion.isMultiple,
                                              activeEquipmentListTab.rotateEquipmentListId,
                                              rotateQuestion.id,
                                              id,
                                              event.target.checked
                                            )
                                          }
                                        />
                                      }
                                      label={name}
                                      key={id}
                                    />
                                  );
                                }
                              )}
                            </FormGroup>
                            <FormHelperText>
                              Select up to {rotateQuestion.rotateAnswers.length}{' '}
                              option
                              {rotateQuestion.rotateAnswers.length > 1
                                ? 's'
                                : ''}
                            </FormHelperText>
                          </>
                        ) : (
                          <>
                            <RadioGroup
                              value={
                                selectedAnswers.find(
                                  ({ rotateEquipmentListId, rotateAnswerId }) =>
                                    rotateEquipmentListId ===
                                      activeEquipmentListTab.rotateEquipmentListId &&
                                    rotateQuestions
                                      .find(
                                        (question) =>
                                          question.id === rotateQuestion.id
                                      )
                                      ?.rotateAnswers.some(
                                        (answer) => answer.id === rotateAnswerId
                                      )
                                )?.rotateAnswerId ?? -1
                              }
                              onChange={(event) =>
                                handleSelectedAnswer(
                                  rotateQuestion.isMultiple,
                                  activeEquipmentListTab.rotateEquipmentListId,
                                  rotateQuestion.id,
                                  parseInt(event.target.value, 10), // Important: radio value is a string
                                  true
                                )
                              }
                            >
                              {rotateQuestion.rotateAnswers.map(
                                ({ id, name }) => {
                                  return (
                                    <FormControlLabel
                                      value={id}
                                      control={<Radio color="primary" />}
                                      label={name}
                                      key={id}
                                    />
                                  );
                                }
                              )}
                            </RadioGroup>
                          </>
                        )}
                      </React.Fragment>
                    );
                  }
                )}
                {nextEquipmentToComplete(
                  activeEquipmentListTab.rotateEquipmentListId
                ).nextEquipment && (
                  <div className={classes.mt1}>
                    <SoftButton
                      endIcon={<ArrowForwardRounded />}
                      onClick={() =>
                        handleClickEquipment(
                          nextEquipmentToComplete(
                            activeEquipmentListTab.rotateEquipmentListId
                          ).nextEquipment?.rotateEquipmentListId
                        )
                      }
                      fullWidth
                    >
                      {`Next: ${
                        nextEquipmentToComplete(
                          activeEquipmentListTab.rotateEquipmentListId
                        ).nextEquipmentName
                      }`}
                    </SoftButton>
                  </div>
                )}
              </>
            )}
          </Collapse>
          <Collapse in={activeStep === 2}>
            <Typography variant="h6">{t('bulkPlanning.labels.documentNo')}</Typography>
            <Divider className={classes.divider} />
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Alert severity="info" icon={<AutoAwesomeRounded />}>
                  {t('bulkPlanning.common.systemUpdateDocuments')}
                </Alert>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t('bulkPlanning.plantCode')}
                  variant="outlined"
                  size="small"
                  name="plant"
                  fullWidth
                  value={code.plant ? code.plant : ''}
                  onChange={handleChangeTextField}
                  placeholder={t('bulkPlanning.common.maxCharacters') as string}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t('bulkPlanning.areaCode')}
                  variant="outlined"
                  size="small"
                  name="area"
                  fullWidth
                  value={code.area ? code.area : ''}
                  onChange={handleChangeTextField}
                  placeholder={t('bulkPlanning.common.maxCharacters') as string}
                />
              </Grid>
              {(code.plant || code.area) && (
                <Grid item xs={12}>
                  <Typography className={classes.px1} variant="caption">
                    {t('bulkPlanning.common.exampleDocumentNo', { originalNo, modifiedNo: modifiedNo(originalNo) })}
                  </Typography>
                </Grid>
              )}
            </Grid>
            <Divider className={classes.my2} />
            <div className={classes.header}>
              <Typography variant="h6">{t('bulkPlanning.labels.revisions')}</Typography>
              {!isEditRevision && (
                <Tooltip title={t('bulkPlanning.tooltips.edit') as string} arrow>
                  <IconButton size="small" onClick={handleEditRevision}>
                    <EditRounded />
                  </IconButton>
                </Tooltip>
              )}
              {isEditRevision && (
                <Tooltip title={t('bulkPlanning.tooltips.newRevision') as string} arrow>
                  <IconButton size="small" onClick={handleNewRevisionTemplate}>
                    <AddRounded />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <Divider className={classes.divider} />
            <Grid container spacing={1}>
              {!isEditRevision && (
                <Grid className={classes.revisionContainer} item xs={12}>
                  {documentRevisions.map((documentRevision, index) =>
                    generateRevisionChip(documentRevision, index)
                  )}
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography className={classes.px1} variant="caption">
                  <b>{t('bulkPlanning.labels.definition')}:</b>{' '}
                  {purposes
                    .map(
                      (purpose) =>
                        `${purpose.abbreviation}: ${purpose.fullName}`
                    )
                    .join(', ')}
                </Typography>
              </Grid>
              {isEditRevision && (
                <>
                  {documentRevisions.map((documentRevision, index) => {
                    const purpose = getValue(
                      documentRevision.purposeId,
                      purposes
                    );
                    const revisionList = purpose?.revisions ?? [];
                    const revision = getValue(
                      documentRevision.revisionId,
                      revisionList
                    );

                    return (
                      <Grid
                        className={classes.flexSpace}
                        item
                        xs={12}
                        key={index}
                      >
                        <Autocomplete
                          className={classes.flexGrow2}
                          id="purpose"
                          options={purposes}
                          getOptionLabel={(option) =>
                            `${option.abbreviation}: ${option.fullName}`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={t('bulkPlanning.tableHeaders.purpose')}
                              variant="outlined"
                              size="small"
                              required
                            />
                          )}
                          value={purpose}
                          onChange={(event, newValue) =>
                            handleChangeRevisionTemplate(
                              newValue?.id ?? null,
                              'purposeId',
                              index
                            )
                          }
                        />
                        <div
                          className={clsx(classes.flexSpace, classes.flexGrow)}
                        >
                          <Autocomplete
                            className={classes.flexGrow}
                            id="revision"
                            options={revisionList}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t('projectDocument.revision')}
                                variant="outlined"
                                size="small"
                                required
                              />
                            )}
                            value={revision}
                            onChange={(event, newValue) =>
                              handleChangeRevisionTemplate(
                                newValue?.id ?? null,
                                'revisionId',
                                index
                              )
                            }
                          />
                          <div>
                            <Tooltip
                              title={
                                documentRevisions.length <= 1
                                  ? (t('bulkPlanning.common.cannotRemove') as string) : (t('bulkPlanning.common.remove') as string)
                              }
                              arrow
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  disabled={documentRevisions.length <= 1}
                                  onClick={() =>
                                    handleRemoveRevisionTemplate(index)
                                  }
                                >
                                  <CloseRounded />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </Grid>
                    );
                  })}
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="primary"
                      variant="outlined"
                      fullWidth
                      onClick={handleResetRevisionTemplate}
                    >
                      {t('bulkPlanning.actions.reset')}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="primary"
                      variant="contained"
                      disableElevation
                      fullWidth
                      disabled={documentRevisions.some(
                        ({ purposeId, revisionId }) => !purposeId || !revisionId
                      )}
                      onClick={handleEditRevision}
                    >
                      {t('bulkPlanning.actions.update')}
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Collapse>
          <Collapse in={activeStep >= 3}>
            <div className={classes.flexSpace}>
              <Typography variant="h6" display="inline">
                {t('bulkPlanning.listOfDocuments')}
              </Typography>
              {bulkDocuments.length > 0 &&
                selectedDocumentRefIds.length === 0 && (
                  <Typography display="inline">
                    {' '}
                    ({bulkDocuments.length} {t('common.document', { count: bulkDocuments.length })})
                  </Typography>
                )}
              {selectedDocumentRefIds.length > 0 && (
                <Typography display="inline">
                  {' '}
                  ({selectedDocumentRefIds.length} {t('bulkPlanning.labels.selected')})
                </Typography>
              )}
            </div>
            <Divider className={classes.divider} />

            {activeStep >= 3 && // To improve the performance, This part will be rendered on it's step only
            bulkDocuments.length > 0 ? (
              <>
                <Tabs
                  indicatorColor="primary"
                  textColor="primary"
                  value={activeEquipmentListTab.index}
                  onChange={handleChangeEquipmentTab}
                >
                  {selectedEquipmentLists.map(({ rotateEquipmentListId }) => {
                    const label = getEquipmentListName(rotateEquipmentListId);
                    const { count, isCompleted } = checkDocumentDetail(
                      rotateEquipmentListId
                    );
                    return (
                      <Tab
                        label={
                          count > 0
                            ? `${label} (${count}) ${isCompleted ? '✅' : '⏳'}`
                            : label
                        }
                        key={label}
                      />
                    );
                  })}
                </Tabs>
                <TableContainer style={{ overflowY: 'hidden' }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell padding="none" width={40} />
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            indeterminate={
                              selectedDocumentRefIds.length > 0 &&
                              selectedDocumentRefIds.length <
                                renderBulkDocumentByPage(
                                  bulkDocuments,
                                  pagination
                                ).length
                            }
                            checked={
                              selectedDocumentRefIds.length > 0 &&
                              selectedDocumentRefIds.length ===
                                renderBulkDocumentByPage(
                                  bulkDocuments,
                                  pagination
                                ).length
                            }
                            onChange={(event) =>
                              handleSelectDocument(event.target.checked)
                            }
                          />
                        </TableCell>
                        <TableCell align="right" width={64}>
                          {t('bulkPlanning.tableHeaders.no')}
                        </TableCell>
                        <TableCell>{t('bulkPlanning.tableHeaders.documentName')}</TableCell>
                        <TableCell>{t('bulkPlanning.tableHeaders.documentNo')}</TableCell>
                        <TableCell>{t('bulkPlanning.tableHeaders.documentLevel')}</TableCell>
                        <TableCell className={classes.creatorField}>
                          {t('bulkPlanning.tableHeaders.documentCreator')}
                          <div>
                            <Badge
                              color="secondary"
                              variant="dot"
                              overlap="circle"
                              invisible={
                                Boolean(anchorElement) || !isShowAllUsers
                              }
                            >
                              <IconButton
                                size="small"
                                edge="end"
                                onClick={handleAnchorElement(true)}
                              >
                                <MoreVertRounded />
                              </IconButton>
                            </Badge>
                          </div>
                          <Menu
                            anchorEl={anchorElement}
                            keepMounted
                            getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                            open={Boolean(anchorElement)}
                            onClose={handleAnchorElement(false)}
                          >
                            <FormControlLabel
                              className={classes.marginFormControlLabel}
                              control={
                                <Checkbox
                                  checked={isShowAllUsers}
                                  onChange={handleChangeRelatedUsers}
                                />
                              }
                              label={t('bulkPlanning.showAllUsers') as string}
                            />
                          </Menu>
                        </TableCell>
                        <TableCell width={40} align="center" padding="none">
                          {selectedDocumentRefIds.length > 0 && (
                            <Tooltip title={t('bulkPlanning.tooltips.delete') as string} arrow>
                              <IconButton
                                size="small"
                                onClick={handleOpenDeleteAllDialog}
                              >
                                <DeleteRounded />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {renderBulkDocumentByPage(bulkDocuments, pagination)
                        .length > 0 ? (
                        renderBulkDocumentByPage(bulkDocuments, pagination).map(
                          (document, index, allDocuments) => {
                            const accessControl = getValue(
                              document.accessControlId,
                              accessControls
                            );
                            const documentTemplate = getValue(
                              document.documentId,
                              documents
                            );
                            const open = getStatus(
                              document.refId,
                              openedDocumentRefIds
                            );
                            const showError =
                              !open &&
                              document.projectDocumentRevisions.some(
                                (documentRevision) =>
                                  !documentRevision.purposeId ||
                                  !documentRevision.revisionId ||
                                  !documentRevision.manHour ||
                                  !documentRevision.planIssueDate ||
                                  !documentRevision.planCompletedDate
                              );
                            const selectedRow = getStatus(
                              document.refId,
                              selectedDocumentRefIds
                            );
                            const selected = showError || selectedRow;
                            const canUndo =
                              selectedDocumentRefIds.length === 0 &&
                              historyDeleteDocumentRevisions.filter(
                                ({ refDocumentId }) =>
                                  refDocumentId === document.refId
                              ).length > 0;
                            const { error, helperText } =
                              checkDocumentNo(document);

                            const count =
                              bulkDocuments.filter(
                                (doc) =>
                                  doc.documentGroupId ===
                                    document.documentGroupId &&
                                  doc.rotateEquipmentListId ===
                                    activeEquipmentListTab.rotateEquipmentListId
                              ).length || 0;
                            const showHeader =
                              index === 0 ||
                              document.documentGroupId !==
                                allDocuments[index - 1].documentGroupId;
                            const selectedDocumentRefInGroup = allDocuments
                              .filter(
                                ({ documentGroupId, rotateEquipmentListId }) =>
                                  documentGroupId ===
                                    document.documentGroupId &&
                                  rotateEquipmentListId ===
                                    activeEquipmentListTab.rotateEquipmentListId
                              )
                              .map((doc) => doc.refId);
                            const indeterminateSelectedRowGroup =
                              selectedDocumentRefInGroup.some((refId) =>
                                selectedDocumentRefIds.includes(refId)
                              );
                            const checkedSelectedRowGroup =
                              selectedDocumentRefInGroup.every((refId) =>
                                selectedDocumentRefIds.includes(refId)
                              );

                            return (
                              <React.Fragment key={index}>
                                {showHeader && (
                                  <TableRow
                                    className={classes.documentGroupRow}
                                  >
                                    <TableCell
                                      align="center"
                                      padding="checkbox"
                                    >
                                      <WhiteCheckbox
                                        indeterminate={
                                          indeterminateSelectedRowGroup &&
                                          !checkedSelectedRowGroup
                                        }
                                        checked={checkedSelectedRowGroup}
                                        onChange={(event) =>
                                          handleSelectDocumentGroup(
                                            event.target.checked,
                                            document.documentGroupId ?? null
                                          )
                                        }
                                        disabled={
                                          document.documentGroupId === undefined
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      className={classes.px0}
                                      colSpan={7}
                                    >
                                      {`${document.documentGroupName} (${count})`}
                                    </TableCell>
                                  </TableRow>
                                )}
                                <TableRow
                                  classes={{
                                    root: clsx(classes.unsetAll, {
                                      [selectedRow
                                        ? classes.tableRowRoot
                                        : classes.tableRowRootError]: selected
                                    }),
                                    selected: clsx({
                                      [selectedRow
                                        ? classes.tableRowSelected
                                        : classes.tableRowSelectedError]:
                                        selected
                                    })
                                  }}
                                  selected={selected}
                                  hover
                                >
                                  <TableCell align="center" padding="none">
                                    <Tooltip
                                      title={open ? (t('bulkPlanning.common.collapse') as string) : (t('bulkPlanning.common.expand') as string)}
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleOpenDocument(document.refId)
                                        }
                                      >
                                        {open ? (
                                          <KeyboardArrowDownRounded />
                                        ) : (
                                          <KeyboardArrowRightRounded />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell align="center" padding="checkbox">
                                    <Checkbox
                                      color="primary"
                                      checked={selectedRow}
                                      onClick={() =>
                                        handleSelectDocument(
                                          !selectedRow,
                                          document.refId
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    {pagination.page * pagination.limit +
                                      index +
                                      1}
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      className={clsx({
                                        [classes.errorInputUnderline]:
                                          !document.name
                                      })}
                                      id="document-name"
                                      name="name"
                                      multiline
                                      fullWidth
                                      helperText={
                                        documentTemplate &&
                                        (!document.name ||
                                          !document.name.includes(
                                            documentTemplate.name
                                          )) &&
                                        `From: ${documentTemplate.name ?? ''}`
                                      }
                                      value={document.name}
                                      onChange={(event) =>
                                        handleChangeDocumentDetail(
                                          event.target.value,
                                          'name',
                                          document.refId
                                        )
                                      }
                                      required
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      className={clsx({
                                        [classes.errorInputUnderline]:
                                          !document.no
                                      })}
                                      id="document-no"
                                      name="no"
                                      multiline
                                      fullWidth
                                      value={document.no}
                                      onChange={(event) =>
                                        handleChangeDocumentDetail(
                                          event.target.value,
                                          'no',
                                          document.refId
                                        )
                                      }
                                      required
                                      error={error}
                                      helperText={helperText}
                                    />
                                  </TableCell>
                                  <TableCell className={classes.notClick}>
                                    <Typography color="textSecondary">
                                      {accessControl?.name ?? ''}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Autocomplete
                                      className={clsx({
                                        [classes.errorInputUnderline]:
                                          !document.documentCreatorId
                                      })}
                                      id="document-creator"
                                      options={getRelatedUser(
                                        document.userIds,
                                        users
                                      )}
                                      getOptionLabel={(option) =>
                                        `${option.firstName} ${option.lastName}`
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          size="small"
                                          required
                                        />
                                      )}
                                      value={getValue(
                                        document.documentCreatorId,
                                        users
                                      )}
                                      onChange={(event, newValue) =>
                                        handleChangeDocumentDetail(
                                          newValue?.id ?? null,
                                          'documentCreatorId',
                                          document.refId
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell
                                    width={64}
                                    align="center"
                                    padding="none"
                                  >
                                    {selectedDocumentRefIds.length === 0 && (
                                      <div className={classes.actionField}>
                                        <Tooltip title={t('bulkPlanning.tooltips.duplicate') as string} arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleDuplicateDocument(document)
                                            }
                                          >
                                            <ContentCopyOutlined />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title={t('bulkPlanning.tooltips.delete') as string} arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenDeleteOneDialog(
                                                document
                                              )
                                            }
                                          >
                                            <DeleteRounded />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    )}
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  classes={{
                                    root: clsx(classes.unsetAll, {
                                      [selectedRow
                                        ? classes.tableRowRoot
                                        : classes.tableRowRootError]: selected
                                    }),
                                    selected: clsx({
                                      [selectedRow
                                        ? classes.tableRowSelected
                                        : classes.tableRowSelectedError]:
                                        selected
                                    })
                                  }}
                                  selected={selected}
                                >
                                  {open && (
                                    <TableCell padding="none" colSpan={8}>
                                      <Table size="small">
                                        <TableHead>
                                          <TableCell>{t('bulkPlanning.tableHeaders.purpose')}</TableCell>
                                          <TableCell>{t('bulkPlanning.tableHeaders.revision')}</TableCell>
                                          <TableCell
                                            align="center"
                                            padding="checkbox"
                                          >
                                            {t('projectDocument.autoApproval')}
                                          </TableCell>
                                          <TableCell width={120}>
                                            {t('bulkPlanning.tableHeaders.manHour')}
                                          </TableCell>
                                          <TableCell>{t('bulkPlanning.tableHeaders.issueDate')}</TableCell>
                                          <TableCell>
                                            {t('bulkPlanning.tableHeaders.completedDate')}
                                            <HelpTooltip>
                                              {t('projectDocument.autoCalculateDate', { days: DAYS_FOR_COMPLETE_REVIEW })}
                                            </HelpTooltip>
                                          </TableCell>
                                          <TableCell
                                            width={40}
                                            align="center"
                                            padding="none"
                                          >
                                            {canUndo && (
                                              <Tooltip title={t('bulkPlanning.tooltips.undo') as string} arrow>
                                                <IconButton
                                                  size="small"
                                                  onClick={() =>
                                                    onUndoDocumentRevision(
                                                      document
                                                    )
                                                  }
                                                >
                                                  <UndoRounded />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                          </TableCell>
                                        </TableHead>
                                        <TableBody>
                                          {document.projectDocumentRevisions.map(
                                            (
                                              documentRevision,
                                              revisionIndex,
                                              documentRevisions
                                            ) => {
                                              const purpose = getValue(
                                                documentRevision.purposeId,
                                                purposes
                                              );
                                              const revisionList =
                                                purpose?.revisions ?? [];
                                              const revision = getValue(
                                                documentRevision.revisionId,
                                                revisionList
                                              );

                                              return (
                                                <TableRow
                                                  className={classes.unsetAll}
                                                  hover
                                                  key={revisionIndex}
                                                >
                                                  <TableCell>
                                                    <Autocomplete
                                                      className={clsx(
                                                        classes.flexGrow2,
                                                        {
                                                          [classes.errorInputUnderline]:
                                                            !purpose
                                                        }
                                                      )}
                                                      id="purpose"
                                                      options={purposes}
                                                      getOptionLabel={(
                                                        option
                                                      ) =>
                                                        `${option.abbreviation}: ${option.fullName}`
                                                      }
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          size="small"
                                                          required
                                                        />
                                                      )}
                                                      value={purpose}
                                                      onChange={(
                                                        event,
                                                        newValue
                                                      ) =>
                                                        handleChangeDocumentRevisionDetail(
                                                          newValue?.id ?? null,
                                                          'purposeId',
                                                          document.refId,
                                                          revisionIndex
                                                        )
                                                      }
                                                    />
                                                  </TableCell>
                                                  <TableCell width={128}>
                                                    <Autocomplete
                                                      className={clsx({
                                                        [classes.errorInputUnderline]:
                                                          !revision
                                                      })}
                                                      id="revision"
                                                      options={revisionList}
                                                      getOptionLabel={(
                                                        option
                                                      ) => option.name}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          size="small"
                                                          required
                                                        />
                                                      )}
                                                      value={revision}
                                                      onChange={(
                                                        event,
                                                        newValue
                                                      ) =>
                                                        handleChangeDocumentRevisionDetail(
                                                          newValue?.id ?? null,
                                                          'revisionId',
                                                          document.refId,
                                                          revisionIndex
                                                        )
                                                      }
                                                    />
                                                  </TableCell>
                                                  <TableCell
                                                    className={clsx({
                                                      [classes.notClick]:
                                                        documentRevision.purposeId !==
                                                        PurposeLabel.IFR
                                                    })}
                                                    align="center"
                                                    padding="checkbox"
                                                  >
                                                    {documentRevision.purposeId ===
                                                      PurposeLabel.IFR && (
                                                      <Checkbox
                                                        checked={
                                                          documentRevision.isAutoApproval
                                                        }
                                                        color="primary"
                                                        disabled={
                                                          documentRevision.purposeId !==
                                                          PurposeLabel.IFR
                                                        }
                                                        onChange={(event) =>
                                                          handleChangeDocumentRevisionDetail(
                                                            event.target
                                                              .checked,
                                                            'isAutoApproval',
                                                            document.refId,
                                                            revisionIndex
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </TableCell>
                                                  <TableCell>
                                                    <TextField
                                                      className={clsx({
                                                        [classes.errorInputUnderline]:
                                                          !documentRevision.manHour
                                                      })}
                                                      type="number"
                                                      size="small"
                                                      value={
                                                        documentRevision.manHour
                                                          ? documentRevision.manHour
                                                          : ''
                                                      }
                                                      onChange={(event) => {
                                                        const parsedValue =
                                                          Number.parseFloat(
                                                            event.target.value
                                                          );
                                                        const value = isNaN(
                                                          parsedValue
                                                        )
                                                          ? null
                                                          : parsedValue;
                                                        handleChangeDocumentRevisionDetail(
                                                          value,
                                                          'manHour',
                                                          document.refId,
                                                          revisionIndex,
                                                          {
                                                            positiveNumber: true
                                                          }
                                                        );
                                                      }}
                                                      required
                                                    />
                                                  </TableCell>
                                                  <TableCell width={200}>
                                                    <KeyboardDatePicker
                                                      className={clsx({
                                                        [classes.errorInputUnderline]:
                                                          !documentRevision.planIssueDate
                                                      })}
                                                      autoOk
                                                      size="small"
                                                      variant="inline"
                                                      InputAdornmentProps={{
                                                        position: 'end'
                                                      }}
                                                      value={
                                                        documentRevision.planIssueDate
                                                      }
                                                      onChange={(event) =>
                                                        handleChangeDocumentRevisionDetail(
                                                          event
                                                            ? moment(event)
                                                                .endOf('day')
                                                                .toDate()
                                                            : null,
                                                          'planIssueDate',
                                                          document.refId,
                                                          revisionIndex
                                                        )
                                                      }
                                                      KeyboardButtonProps={{
                                                        'aria-label':
                                                          t('projectDocument.changePlanIssueDate') as string
                                                      }}
                                                      required
                                                    />
                                                  </TableCell>
                                                  <TableCell width={200}>
                                                    <KeyboardDatePicker
                                                      className={clsx({
                                                        [classes.errorInputUnderline]:
                                                          !documentRevision.planIssueDate
                                                      })}
                                                      autoOk
                                                      size="small"
                                                      variant="inline"
                                                      InputAdornmentProps={{
                                                        position: 'end'
                                                      }}
                                                      minDate={
                                                        documentRevision.planIssueDate
                                                      }
                                                      minDateMessage={t('bulkPlanning.common.dateValidation')}
                                                      value={
                                                        documentRevision.planCompletedDate
                                                      }
                                                      onChange={(event) =>
                                                        handleChangeDocumentRevisionDetail(
                                                          event
                                                            ? moment(event)
                                                                .endOf('day')
                                                                .toDate()
                                                            : null,
                                                          'planCompletedDate',
                                                          document.refId,
                                                          revisionIndex
                                                        )
                                                      }
                                                      KeyboardButtonProps={{
                                                        'aria-label':
                                                          t('projectDocument.changeCompleteIssueDate') as string
                                                      }}
                                                      required
                                                    />
                                                  </TableCell>
                                                  <TableCell
                                                    width={40}
                                                    align="center"
                                                    padding="none"
                                                  >
                                                    {selectedDocumentRefIds.length ===
                                                      0 && (
                                                      <Tooltip
                                                        title={
                                                          documentRevisions.length <=
                                                          1
                                                            ? (t('bulkPlanning.common.cannotDelete') as string) : (t('bulkPlanning.tooltips.delete') as string)
                                                        }
                                                        arrow
                                                      >
                                                        <span>
                                                          <IconButton
                                                            size="small"
                                                            disabled={
                                                              documentRevisions.length <=
                                                              1
                                                            }
                                                            onClick={() =>
                                                              onDeleteDocumentRevision(
                                                                document,
                                                                documentRevision
                                                              )
                                                            }
                                                          >
                                                            <DeleteRounded />
                                                          </IconButton>
                                                        </span>
                                                      </Tooltip>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )}
                                        </TableBody>
                                      </Table>
                                    </TableCell>
                                  )}
                                </TableRow>
                              </React.Fragment>
                            );
                          }
                        )
                      ) : (
                        <TableRow className={classes.unsetAll}>
                          <TableCell colSpan={8} align="center">
                            <div className={classes.notFoundError}>
                              No document in this equipment
                            </div>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className={clsx(classes.pagination, classes.mt1)}>
                  <Pagination
                    count={Math.ceil(
                      bulkDocuments.filter(
                        ({ rotateEquipmentListId }) =>
                          rotateEquipmentListId ===
                          activeEquipmentListTab.rotateEquipmentListId
                      ).length / pagination.limit
                    )}
                    shape="rounded"
                    page={pagination.page + 1}
                    onChange={handleChangePage}
                  />
                </div>
              </>
            ) : templateWithDocument.flatMap(({ documents }) => documents)
                .length === 0 ? (
              <div className={classes.notFoundError}>
                <Typography gutterBottom>{t('bulkPlanning.oops')}</Typography>
                <Typography component="div" variant="caption">
                  {t('bulkPlanning.common.oopsCannotDisplay')}
                </Typography>
                <Typography component="div" variant="caption" gutterBottom>
                  {t('bulkPlanning.common.checkMasterData')}
                </Typography>
              </div>
            ) : (
              <div className={classes.notFoundError}>
                <Typography gutterBottom>{t('bulkPlanning.omg')}</Typography>
                <Typography component="div" variant="caption">
                  {t('bulkPlanning.common.omgDeletedAll')}
                </Typography>
                <Typography component="div" variant="caption" gutterBottom>
                  {t('bulkPlanning.common.clickResetDefault')}
                </Typography>
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  onClick={onReset}
                >
                  {t('bulkPlanning.common.reset')}
                </Button>
              </div>
            )}
          </Collapse>
        </Paper>
        <div className={classes.actionButton}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<KeyboardArrowLeftRounded />}
            disabled={activeStep === 0}
            onClick={handleBack}
          >
            {t('projectCreate.back')}
          </Button>
          {activeStep < stepKeys.length - 1 ? (
            <Button
              variant="contained"
              color="primary"
              size="large"
              endIcon={<KeyboardArrowRightRounded />}
              disabled={nextButton(activeStep).disabled}
              onClick={nextButton(activeStep).action}
            >
              {t('projectCreate.next')}
            </Button>
          ) : (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={nextButton(activeStep).disabled}
            >
              {t('bulkPlanning.actions.createDocuments')}
            </Button>
          )}
        </div>
      </form>
      <BulkUpdateDetail
        documents={bulkDocuments}
        setDocuments={setBulkDocuments}
        documentRefIds={selectedDocumentRefIds}
        setDocumentRefIds={setSelectedDocumentRefIds}
        show={activeStep === 3}
      />
      <ConfirmDeleteBox
        open={openDeleteOneDialog}
        text={selectedDocument?.name ?? t('bulkPlanning.common.untitledDocument') as string}
        onDelete={onDeleteDocument}
        onClose={handleOpenDeleteOneDialog}
      />
      <ConfirmDeleteBox
        open={openDeleteAllDialog}
        text={`${selectedDocumentRefIds.length} document${
          selectedDocumentRefIds.length > 1 ? 's' : ''
        }`}
        onDelete={onDeleteSelectedDocuments}
        onClose={handleOpenDeleteAllDialog}
      >
        <ul className={classes.ul}>
          {selectedDocumentRefIds.map((refId) => {
            const document = bulkDocuments.find(
              (document) => document.refId === refId
            );
            return <li key={refId}>{document?.name ?? t('bulkPlanning.common.untitledDocument')}</li>;
          })}
        </ul>
      </ConfirmDeleteBox>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { margin: theme.spacing(1.5, 0, 12, 0) },
    title: {
      margin: theme.spacing(1.5, 0, 2, 0),
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
        margin: theme.spacing(3.5, 0, 4, 0)
      }
    },
    card: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: theme.spacing(2)
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    divider: {
      margin: theme.spacing(0.5, 0, 2, 0),
      width: theme.spacing(4)
    },
    documentGroupRow: {
      backgroundColor: theme.palette.text.primary,
      '& > *': {
        color: theme.palette.background.paper,
        borderBottom: 'unset'
      }
    },
    clickable: { cursor: 'pointer' },
    notClick: { cursor: 'not-allowed' },
    unsetAll: {
      '& > *': {
        borderBottom: 'unset'
      }
    },
    unset: { borderBottom: 'unset' },
    tableRowRoot: {
      '&$tableRowSelected, &$tableRowSelected:hover': {
        backgroundColor: fade(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    },
    tableRowSelected: {
      backgroundColor: fade(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity
      )
    },
    equipmentDetailField: {
      display: 'flex',
      gap: theme.spacing(0.5),
      flexWrap: 'wrap',
      margin: theme.spacing(1, 0, 0.5, 0),
      '& > :first-child': {
        marginTop: theme.spacing(0.5) // adjust spacing as needed
      }
    },
    tableRowRootError: {
      '&$tableRowSelected, &$tableRowSelected:hover': {
        backgroundColor: fade(
          theme.palette.secondary.main,
          theme.palette.action.selectedOpacity
        )
      }
    },
    tableRowSelectedError: {
      backgroundColor: fade(
        theme.palette.secondary.main,
        theme.palette.action.selectedOpacity
      )
    },
    errorInputUnderline: {
      '& .MuiInput-underline:before, & .MuiInput-underline:hover:not(.Mui-disabled):before, & .MuiInput-underline:after':
        {
          borderBottomColor: theme.palette.error.main,
          borderBottomWidth: 2
        }
    },
    creatorField: {
      padding: theme.spacing(0.75, 2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    actionField: {
      display: 'flex',
      alignItems: 'center'
    },
    revisionContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
      marginBottom: theme.spacing(1)
    },
    flexSpace: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center'
    },
    truncatedChip: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%' // Adjust this to control the maximum width of the Chip
    },
    notFoundError: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: theme.spacing(1, 2)
    },
    fileNotFound: {
      padding: theme.spacing(2, 1),
      textAlign: 'center'
    },
    pagination: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    marginFormControlLabel: { margin: theme.spacing(0, 1.5, 0, 0) },
    ul: { paddingLeft: theme.spacing(2) },
    actionButton: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    flexGrow: { flexGrow: 1 },
    flexGrow2: { flexGrow: 2 },
    mt1: { marginTop: theme.spacing(1) },
    my2: { margin: theme.spacing(2, 0) },
    px0: { paddingLeft: 0, paddingRight: 0 },
    px1: { padding: theme.spacing(0, 1) },
    pt2: { paddingTop: theme.spacing(2) }
  })
);
